<template>
  <div class="HeadNavigation">
    <el-breadcrumb separator="/" style="padding: 0">
      <el-breadcrumb-item style="cursor: pointer">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        style="cursor: pointer"
        v-for="(item, i) in $root.headName"
        :key="i"
        >{{ item }}</el-breadcrumb-item
      >
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'HeadNavigation',
  props: {},
  methods: {},
  created() {},
};
</script>
<style scoped>
.HeadNavigation {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  margin-bottom: 20px;
}
</style>
